import type { Character } from "@cloudnest/horror-race-engine";

export const CHARACTER_LABELS: Record<Character, string> = {
  VAMPIRE: "뱀파이어",
  JIANGSHI: "강시",
  GUMIHO: "구미호",
  MUMMY: "미이라",
  ZOMBIE: "좀비",
};

// Each archetype maps to its dedicated character-token hue (T3/T4). These
// tokens are reserved strictly for character identity — never shared with
// player seat colors or chrome accents. Mapping matches the wireframe's
// data-hr-dot reference (docs/wireframes/horror-race/02-components.html §02.1).
export const CHARACTER_COLORS: Record<Character, string> = {
  VAMPIRE: "var(--cn-horror-char-vampire)",
  JIANGSHI: "var(--cn-horror-char-jiangshi)",
  GUMIHO: "var(--cn-horror-char-gumiho)",
  MUMMY: "var(--cn-horror-char-mummy)",
  ZOMBIE: "var(--cn-horror-char-zombie)",
};
